<div class="header">
    <div class="buttonBack" (click)="onClickBack($event)">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <i class="fa fa-times" aria-hidden="true"></i>
    </div>
    <shared-booking-header #bookingHeader *ngIf="actionId != 'ADD'" [booking]="selectedBooking">
    </shared-booking-header>
    <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>

    <div class="zonaOptions" *ngIf="selectedBooking && selectedBooking.bookingId && selectedRoute == null" [@fadeInOut]>
        <div class="formarara">
            <options [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
        </div>
        <shared-booking-state *ngIf="actionId != 'DELETE' && (selectedOptionId == 'EDIT' || actionId == 'ADD')"
            [booking]="selectedBooking" [readonly]="readonly"
            (onBookingStateChange)="onBookingStateChange($event)"></shared-booking-state>
    </div>
</div>
<div #scrollContainer *ngIf="selectedBooking" class="desplegable" [ngClass]="{'selectedRoute':selectedRoute}">
    <div class="dummy"></div>
    <shared-active-bookings-item-manage *ngIf="actionId != 'DELETE' && selectedOptionId == 'MANAGE'" class="detall"
        [bookingId]="selectedBooking.bookingId" [readonly]="readonly" (reloadBooking)="onReloadBooking($event)"
        (selectRouteChange)="onSelectRouteChange($event)">
    </shared-active-bookings-item-manage>
    <shared-active-bookings-item-removeroute *ngIf="actionId != 'DELETE' && selectedOptionId == 'ROUTES'" class="detall"
        [bookingId]="selectedBooking.bookingId" [readonly]="readonly"
        (finishRemoveRoutes)="onFinishRemoveRoutes($event)">
    </shared-active-bookings-item-removeroute>
    <shared-active-bookings-item-addroute *ngIf="actionId != 'DELETE' && selectedOptionId == 'ADDROUTES'" class="detall"
        [bookingId]="selectedBooking.bookingId" [readonly]="readonly" (finishAddRoutes)="onFinishAddRoutes($event)">
    </shared-active-bookings-item-addroute>

    <shared-booking-form *ngIf="actionId != 'DELETE' && (selectedOptionId == 'EDIT' || actionId == 'ADD')"
        class="detall" [selectedBooking]="selectedBooking" (onSave)="onSave($event)">
    </shared-booking-form>
    <shared-active-bookings-item-conflict *ngIf="actionId != 'DELETE' && selectedOptionId == 'CONFLICTS'" class="detall"
        [bookingId]="selectedBooking.bookingId" [readonly]="readonly"
        (finishConflictRoutes)="onFinishConflictRoutes($event)">
    </shared-active-bookings-item-conflict>
    <shared-deleteobject class="extramargin" *ngIf="actionId == 'DELETE'" (onDelete)="onDelete($event)"
        (onCancelDelete)="onCancelDelete($event)" [value]="selectedBooking">{{'SHARED.ACTIVEBOOKING.DELETE.HELP' |
        translate}}</shared-deleteobject>
</div>